import { createSelector } from 'reselect';
import { careerAndSeasonStatsSelector } from './simple-selectors';

export const careerAndSeasonStatsNavSelector = createSelector(
    careerAndSeasonStatsSelector,
    careerAndSeasonStats => careerAndSeasonStats.nav
);